
const createProdLogger = () => next => action => {
    const actionType = action.type;
    window.console.log('action:', actionType);
    return next(action);
};

export default createProdLogger;



/** WEBPACK FOOTER **
 ** ./src/store/middleware/ProdLogger.js
 **/